import { message } from "antd";

import { BaseList, BaseDetail } from "App/Component/Bases";
import fields from "./fields";
import descriptor from "./descriptor";
import options from "./options";

const title = "Override Lines";
const urlData = "overrideLines";
const bulkName = "override_set.name";

class List extends BaseList {
  constructor(props) {
    super(props)

    this.title = title;
    this.urlData = urlData;
    this.bulkName = bulkName;
    this.propsList = {
      descriptor,
      exportImport: options.exportImportOptions,
      onExportClick: () => message.info('Do export from Overrideset page'),
      onImportClick: () => message.info('Do import from Overrideset page'),
    }
  }
}

class Detail extends BaseDetail {
  constructor(props) {
    super(props)

    this.title = title
    this.urlData = urlData
    this.bulkName = bulkName
    this.fields = fields
    this.propsDetail = {
      urlKeyHistory: 'api:admin:estimation:overrideline:detail-revision',
      keyLabel: 'line_template.label'
    }
  }
}

export default { List, Detail };